// Registry SaveSlice (TECH_BASELINE §6.1): mỗi module khai một slice; persistence gom lại để lưu.
import type { SaveDoc } from '@save/types';

export type SliceScope = 'core' | 'device';

export interface SaveSlice<T> {
  readonly key: string;
  readonly scope: SliceScope;
  serialize(): T;
  /** `data` là undefined khi doc cũ chưa có slice này: phải về mặc định đúng nghĩa. */
  hydrate(data: unknown): void;
}

const slices = new Map<string, SaveSlice<unknown>>();

export function registerSlice<T>(slice: SaveSlice<T>): void {
  const id = `${slice.scope}:${slice.key}`;
  if (slices.has(id)) throw new Error(`duplicate save slice ${id}`);
  slices.set(id, slice as SaveSlice<unknown>);
}

export function hydrateAll(doc: SaveDoc): void {
  for (const s of slices.values()) s.hydrate(s.scope === 'core' ? doc.core[s.key] : doc.device[s.key]);
}

/** Dựng doc mới từ khung (v, seed, createdAt) + dữ liệu hiện tại của mọi slice. */
export function collectDoc(base: SaveDoc, savedAt: number): SaveDoc {
  const core: Record<string, unknown> = { ...base.core };
  const device: Record<string, unknown> = { ...base.device };
  for (const s of slices.values()) (s.scope === 'core' ? core : device)[s.key] = s.serialize();
  return { ...base, savedAt, core: core as SaveDoc['core'], device };
}
